import React from 'react';

export default function StatusBadge({ status }) {
  const className = `badge badge-${status?.replace(/_/g, '-') || 'draft'}`;
  const label = status?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) || 'Unknown';
  return <span className={className}>{label}</span>;
}
